<template>
  <div class="table-base">
    <ul :class="{'table-notbuy': notBuyFlag}">
      <li class="details_ttl">
        <span>商品名</span>
        <span>数量</span>
        <span v-if="!notBuyFlag" class="details_price">金額</span>
        <span class="details_remarks">備考</span>
      </li>
      <li v-for="item in itemsSource" :key="item.title" class="details_cnt">
        <span>{{item.title}}</span>
        <span>{{item.amount}}</span>
        <template v-if="item.not_buy"></template>
        <template v-else>
          <span class="details_price">{{item.price | yen}}</span>
        </template>
        <template v-if="item.price_down_reasons">
          <span class="details_remarks">{{item.price_down_reasons[0]}}</span>
        </template>
        <template v-else>
          <span class="details_remarks"></span>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "itemsTable",
  props: ["itemsSource"],
  computed: {
    notBuyFlag() {
      return this.itemsSource.some(item => item.not_buy);
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin: 10px 0;
  overflow: hidden;
  padding: 0;
}
li {
  box-sizing: border-box;
  list-style-type: none;
  overflow: hidden;
}
.details_ttl {
  background-color: #fffaea;
  border-bottom: 1px solid #ccc;
  display: flex;
  text-align: center;
  span {
    float: left;
    padding: 2px 5px;
    box-sizing: border-box;
    &:not(:last-child) {
      border-right: 1px solid #ccc;
    }
    &:first-child {
      width: 30%;
      display: block;
    }
  }
}
.details_cnt {
  background-color: #fff;
  display: flex;
  text-align: center;
  &:nth-of-type(odd) {
    background-color: #f4f4f4;
  }
  span {
    float: left;
    padding: 2px 5px;
    box-sizing: border-box;
    &:not(:last-child) {
      border-right: 1px solid #ccc;
    }
    &:first-child {
      width: 30%;
      display: block;
      text-align: left;
    }
  }
}
.details_ttl span:nth-child(2),
.details_cnt span:nth-child(2) {
  width: 10%;
  display: block;
}
.details_ttl span.details_price,
.details_cnt span.details_price {
  width: 15%;
  display: block;
}
.details_ttl span.details_remarks {
  width: 45%;
  display: block;
}
.details_cnt span {
  &.details_price {
    text-align: right;
  }
  &.details_remarks {
    text-align: left;
    width: 45%;
    display: block;
  }
  small {
    color: #df4726;
    font-size: 13px;
    margin-left: 5px;
  }
}
.table-notbuy {
  .details_ttl span.details_remarks {
    width: 60%;
  }
  .details_cnt span {
    &.details_remarks {
      width: 60%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ItemsTable.vue